module.exports = __webpack_public_path__ + "static/img/bg2.472a6202.jpg";